export const routerOptions = {
    routes: {
        "search(/:query)(/:page)(/:order)(/)(?exact=:exact)(?availableDate=:availableDate)": "search",
        "browsesearch/:query/:page/:order": "search",
        "advancedsearch(/:formID)": "showAdvancedSearch",
        "signin": "signIn",
        "signout": "signOut",
        "auth(/)": "auth",
        "signin?return=:returnUrl": "signIn",
        "signin?email=:email&return=:returnUrl": "signIn",
        "override": "override",
        "override?return=:returnUrl": "override",
        "settings": "settings",
        "browse(/*levels)": "browse",
        "desktop": "showDesktop",
        "links/:id": "links",
        "history(/:timeSpan)(/:page)": "showUserHistory",
        "case/:name/:section/:id(/:paranum)": "caseDocument",
        "eu_sector:sector/:name/:section/:id(/:paranum)": "EUDocument",
        "importstatus(/?datasource=:datasource)" : "importStatus",
        "precedent-map/:name/:id/:unique": "precedentMap",
        "category(/:name)(/:section)/:id": "categoryDocument",
        "statute/:name(/:statutesection)/:section/:id": "legislationDocument",
        "si/:name/:section/:id": "statutoryInstrumentDocument",
        "document(/:name)(/:section)/:id": "genericDocument",
        "tour/:step": "tour",
        "wayfless?*queryString": "wayfless",
        "active-directory(?*queryString)": "activeDirectoryDirect",
        "processing*subroute" : "invokeProcessingPackage",
        "error/:httpCode" : "error",
        "my-justis(/:section)(/:subsection)": "showMyJustis",
        "testmap": "testMap",
        "shibbolethlogin": "shibbolethLoginViaWayfless",
        "": "home",
        "*path": "home"
    }
};



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/router-settings.ts